import { CommonModule, AsyncPipe, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { FuseScrollbarDirective } from '@fuse/directives/scrollbar';
import { DmsFileItem } from 'app/models/dms-file-item';
import { Observable } from 'rxjs';
import { FileUploadQueueService } from 'app/services/file-upload-queue.service';
import { Util } from 'app/models/util';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'upload-queue-popup',
    templateUrl: './upload-queue-popup.component.html',
    styleUrls: ['./upload-queue-popup.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        CommonModule,
        AsyncPipe,
        NgFor,
        NgIf,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatExpansionModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatDividerModule,
        FuseScrollbarDirective
    ],
    animations: [
        trigger('slideUp', [
            state('void', style({ opacity: 0, transform: 'translateY(20px)' })),
            transition(':enter', [
                animate('250ms ease-out', style({ opacity: 1, transform: 'translateY(0)' }))
            ]),
            transition(':leave', [
                animate('200ms ease-in', style({ opacity: 0, transform: 'translateY(20px)' }))
            ])
        ])
    ]
})
export class UploadQueuePopupComponent implements OnInit {

    @ViewChild('uploaderPanel') uploaderPanel: MatExpansionPanel;

    queue$: Observable<DmsFileItem[]>;
    isVisible$: Observable<boolean>;
    queueHeader$: Observable<string>;
    isPreparing$: Observable<boolean>;
    panelOpenState = true;

    constructor(
        private uploadQueueService: FileUploadQueueService,
        private _fuseConfirmationService: FuseConfirmationService,
        private util: Util,
    ) {}

    ngOnInit(): void {
        this.queue$       = this.uploadQueueService.queue$;
        this.isVisible$   = this.uploadQueueService.isVisible$;
        this.queueHeader$ = this.uploadQueueService.queueHeader$;
        this.isPreparing$ = this.uploadQueueService.isPreparing$;
    }

    // ── UI helpers ───────────────────────────────────────────────────────────────

    getProgress(item: DmsFileItem): number  { return this.util.getProgress(item); }
    getIcon(item: DmsFileItem): string      { return this.util.getIcon(item); }
    getIconColor(item: DmsFileItem): string { return this.util.getIconColor(item); }

    togglePanel(panel: MatExpansionPanel, event: MouseEvent): void {
        event.stopPropagation();
        panel.toggle();
    }

    // ── Actions ──────────────────────────────────────────────────────────────────

    cancelFile(file: DmsFileItem): void {
        this.uploadQueueService.cancelItem(file);
    }

    removeFile(file: DmsFileItem): void {
        this.uploadQueueService.removeItem(file);
    }

    onCloseClick(event: MouseEvent): void {
        event.stopPropagation();
        const uploader = this.uploadQueueService.uploader;
        const hasActiveUploads = uploader?.isUploading;

        if (hasActiveUploads) {
            const dialogRef = this._fuseConfirmationService.open(Util.cancelForm as any);
            dialogRef.afterClosed().subscribe(result => {
                if (result === 'confirmed') {
                    uploader.cancelAll();
                    this.uploadQueueService.uploader.clearQueue();
                    this.uploadQueueService.updateQueueHeader();
                    this.uploadQueueService.uploader.isUploading = false;
                    this.uploadQueueService.dismiss(true);
                }
            });
        } else {
            this.uploadQueueService.dismiss(true);
        }
    }

}
